module.exports = __webpack_public_path__ + "dcb73f3d3648fa1bcd340e7eeda45a16.svg";